import React from 'react'


function ApplicantList() {
    return <h1>applicants</h1>
}

export default ApplicantList;